module.exports = __webpack_public_path__ + "img/煤矿“三链五全”价值链管理体系的构建与实施—山东能源枣庄矿业（集团）高庄煤业有限公司—1-1.704291d7.jpg";